// Extremely generic binary search implementation.
// Can be used to find lowerBounds, upperBounds and everything in between
// by using a suitable compare function!

const binSearch = (arr, compare) => {
	if (!Array.isArray(arr) || arr.length < 1) return -1;
	const n = arr.length;
	let left = 0,
		right = n;
	let ans = -1;
	while (left < right) {
		let mid = left + Math.floor((right - left) / 2);
		const { found, nextLeft, nextRight } = compare(left, mid, right);
		if (found) ans = mid;
		left = nextLeft;
		right = nextRight;
	}
	return ans;
};

export default binSearch;
